import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoProfileUser = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>ProfileUser</title>
    <circle cx={16.001} cy={10.779} r={7.683} stroke="currentColor" strokeWidth={2} />
    <path
      d="M4.983 26.156a1.18 1.18 0 0 1-.118-1.55 13.904 13.904 0 0 1 11.137-5.566c4.554 0 8.596 2.185 11.137 5.564a1.18 1.18 0 0 1-.118 1.55c-2.867 2.837-6.748 4.578-11.02 4.578-4.271 0-8.151-1.74-11.018-4.576Z"
      stroke="currentColor"
      strokeWidth={2}
    />
  </svg>
);
export default SvgIcoProfileUser;
